import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Tr } from '@utils';
import { RoleWithAssignees, UserInvitation } from '@services';
import { Box, Grid } from '@mui/material';
import { VoltaageModalDialog, IVoltaageModalDialogProps, StripedTableCell } from '@components/common';

export interface IRoleAssigneesDialogProps extends IVoltaageModalDialogProps {
	entity?: RoleWithAssignees;
}

export const RoleAssigneesDialog: FC<IRoleAssigneesDialogProps> = ({ entity, ...props }) => {
	const { t } = useTranslation('portal');
	return (
		<VoltaageModalDialog title={<Tr.Portal path="roles.assignees-modal-title" />} dividers {...props}>
			<Box sx={{ paddingX: 10, paddinTop: 3, paddingBottom: 5 }}>
				<Grid container>
					{entity?.assignees.map((assignee, i) => {
						return (
							<Fragment key={`assignee-${assignee.email}-${i}`}>
								<StripedTableCell title={<Tr.Portal path="roles.name" />} greyBg={!!(i % 2)}>
									{`${[assignee.name, assignee.surname].filter(Boolean).join(' ')}${
										assignee instanceof UserInvitation ? ` (${t('collaborators.tab-pending')})` : ''
									}`}
								</StripedTableCell>
								<StripedTableCell title={<Tr.Portal path="roles.email" />} greyBg={!!(i % 2)}>
									{assignee?.email || '-'}
								</StripedTableCell>
							</Fragment>
						);
					})}
				</Grid>
			</Box>
		</VoltaageModalDialog>
	);
};
